import http from '@/core/services/drivers/app-http-driver'

export default {
  config: {
    index (params = {}) {
      return http({ url: `/core/web/config`, method: 'get', params: params })
    },
  },
}
